import RMSvgIcon, {
  RMSvgIconProps,
} from 'components/customComponents/CommonComponents/RMSvgIcon';
import React from 'react';
import { customTabIconProps } from 'utils/Global';
interface CustomTabProps {
  IconProps: RMSvgIconProps;
  title?: string;
  active: any;
  disabled?: boolean;
  titleTip?: string;
}

const TabButton = (props: CustomTabProps) => {
  const { IconProps, title, active, disabled, titleTip } = props;
  return (
    <>
      <div
        id={`tab-${titleTip.toLowerCase()}-button-container`}
        className={`${
          active ? 'active-custom-tab' : 'custom-tab-common cursor-pointer'
        } ${disabled ? 'disabled-container' : ''}`}
        {...(titleTip && { title: titleTip })}
      >
        <RMSvgIcon {...IconProps} {...customTabIconProps} />
      </div>
      {title && (
        <div id={`tab-button-title-${title.toLowerCase()}`} style={{ marginTop: 5, textAlign: 'center' }}>
          {title}
        </div>
      )}
    </>
  );
};

export default TabButton;
